/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type VehicleType } from '@/constants/images/fitmentIcons';

/**
 * Normalizes vehicle type name to a standard category.
 * Supports both English and Spanish vehicle type names for US and MX sites.
 * @param vehicleTypeName - Vehicle type from VehicleSummary (e.g., 'Motorcycle', 'Motocicletas', 'Recreation', 'Recreativos', 'Car & Truck', 'Autos y Camionetas')
 * @returns Normalized vehicle type category
 */
export const getVehicleTypeCategory = (vehicleTypeName: string | undefined): VehicleType => {
  if (!vehicleTypeName) {
    return 'car';
  }

  const normalized = vehicleTypeName.toLowerCase().trim();

  // Support both English and Spanish vehicle type names
  if (
    normalized.includes('motorcycle') ||
    normalized === 'moto' ||
    normalized.includes('motocicleta')
  ) {
    return 'motorcycle';
  }

  if (
    normalized.includes('recreation') ||
    normalized === 'rec' ||
    normalized.includes('recreativo')
  ) {
    return 'recreation';
  }

  // Default to car for 'Car & Truck' and unknown types
  return 'car';
};
